export const TENNIS_BRACELET = 'tennis_bracelet';
export const TENNIS_NECKLACE = 'tennis_necklace';
export const IGI_UPCHARGE = 350;
export const TENNIS_OPTIONS = ['14K White, No Cert', '14K White, IGI Cert', '14K Yellow, No Cert', '14K Yellow, IGI Cert'];

// Mirrors backend lib/tennis.py CONFIG / spec_fields / spec_defaults.
const specFields = (noun, Noun, d) => [
  { key: `${noun}_style`, label: `${Noun} Style`, placeholder: 'Blank = AI reads it from the source' },
  { key: 'total_carat_weight', label: 'Total Carat Weight', def: d.tcw },
  { key: `${noun}_length`, label: `${Noun} Length`, def: d.length },
  { key: 'diamond_color', label: 'Diamond Color', def: 'E-F' },
  { key: 'diamond_clarity', label: 'Diamond Clarity', def: d.clarity },
  { key: 'lock_type', label: 'Lock Type', def: d.lock },
  { key: 'delivery_time', label: 'Delivery Time', def: d.delivery },
  { key: 'metal_type', label: 'Metal Type', def: '14K Solid White Gold or 14K Solid Yellow Gold' },
];

export const TENNIS_CONFIG = {
  [TENNIS_BRACELET]: {
    label: 'Tennis Bracelet',
    noun: 'bracelet',
    carats: [3, 5, 7, 10, 12, 15],
    priceNote: '',
    tljNote: 'Etsy price − $50 · IGI certification (+$350) and 6.5"/7" length are chosen by the shopper on the site.',
    specFields: specFields('bracelet', 'Bracelet', {
      tcw: '3, 5, 7, 10, 12 or 15 CT TW, depending on your selection',
      length: '7 inches (custom lengths available on request)',
      clarity: 'VS+', lock: 'Box clasp with double safety latch', delivery: 'Ships in 2–4 days',
    }),
  },
  [TENNIS_NECKLACE]: {
    label: 'Tennis Necklace',
    noun: 'necklace',
    carats: [5, 7, 10, 12, 15, 20, 25],
    priceNote: 'Price = 16" necklace. The listing says 17" is available on request.',
    tljNote: 'Etsy price − $50 (16" price) · 17" (+$175) and IGI certification (+$350) are chosen by the shopper on the site.',
    specFields: specFields('necklace', 'Necklace', {
      tcw: '5, 7, 10, 12, 15, 20 or 25 CT TW, depending on your selection',
      length: '16 inches (17 inches available on request)',
      clarity: 'VS1+', lock: 'Box clasp with double safety', delivery: '2-3 weeks',
    }),
  },
};

export const isTennis = (pt) => Object.prototype.hasOwnProperty.call(TENNIS_CONFIG, pt || '');
export const tennisCarats = (pt) => TENNIS_CONFIG[pt]?.carats || [];

export const tennisPricesComplete = (p, pt) => {
  const carats = tennisCarats(pt);
  return carats.length > 0 && carats.every((c) => Number(p?.[c]) > 0);
};

export const tennisPricesPayload = (p, pt) =>
  Object.fromEntries(tennisCarats(pt).map((c) => [String(c), Number(p?.[c])]));

export const tennisPriceRange = (p, pt) => {
  if (!tennisPricesComplete(p, pt)) return null;
  const vals = tennisCarats(pt).map((c) => Number(p[c]));
  return { min: Math.min(...vals), max: Math.max(...vals) + IGI_UPCHARGE, count: vals.length * TENNIS_OPTIONS.length };
};
